export const HEADER_TEXT = 'Select your bank';
